<template>
  <div class="content" v-if="dataReady">
    <big-one :content="content" :type = "type" :a-page="true" :tuning="true" :default-sort="'nextDate'"></big-one>
  </div>
</template>
<script>

const tsrBaseTsrName = {header: "Наименование", name: "basis.name", show: true, contains: ""};
const tsrNextDate = {header: "Следующая дата", name: "nextDate", show: true, sort: true, direction: true, valueFilter: true, before: null, after: null, date: true};
const tsrIprClient = {header: "Клиент", name: "ipr.client.name", show: true};
const tsrCostPrice = {header: "Стоимость", name: "costPrice", show: true, sort: true, direction: true}
const tsrCompensation = {header: "Компенсация", name: "compensation", show: false, sort: true, direction: true}
const clientAddress = {header: "Адрес", name: "ipr.client.contact.address", show: true, contains: "", cut: [8,45]};
const isArchivedSelector = {selector: true, title: "Статус клиентов", name: "archivedDate", selectorList: null, contains: "null"}

export default{
  data() {
    return {
      type: "tsr",
      content: [tsrBaseTsrName, tsrNextDate, tsrCostPrice, tsrCompensation, tsrIprClient, clientAddress, isArchivedSelector],
      newOne: null,
      archivedList: null,
      dataReady: false
    }
  },
  methods: {
  },
  async mounted() {
    isArchivedSelector.selectorList = await this.$repo.getSelector("archived");
    this.dataReady = true;
  }
}
</script>
<style>
</style>
